import StatisticsBlock, { StatisticsBlockStatisticType } from '@/components/StatisticsBlock';
import { Customers_Customer_Entry, Maybe, ModuleStatisticsBlockFragment } from '@/graphql';
import { parseHtml } from '@/lib/parse-html';
import { getSingle, notEmpty } from '@/lib/typescript-helpers';
import { FC } from 'react';

interface StatisticsBlockModuleProps {
  props: CraftModuleFragment<ModuleStatisticsBlockFragment>;
}

const StatisticsBlockModule: FC<StatisticsBlockModuleProps> = ({ props }) => {
  if (Array.isArray(props)) {
    props = props[0];
  }

  if (!props) return null;

  return (
    <StatisticsBlock
      heading={props.heading ?? ''}
      statistics={
        props.statisticBlocks
          ?.map((stat): StatisticsBlockStatisticType | null => {
            if (!stat) return null;

            const customer = getSingle(stat.customerLogo) as Maybe<Customers_Customer_Entry>;
            const logo = getSingle(customer?.monochromeCustomerLogo);

            const logoObj = {
              url: logo?.url ?? '',
              width: logo?.width ?? 0,
              height: logo?.height ?? 0,
              isLarger: customer?.isMonochromeLogoTaller ?? false,
            };

            if (stat.__typename === 'statisticBlocks_countUpStatistic_BlockType') {
              return {
                id: stat.id ?? '',
                countUp: true,
                statistic: stat.number,
                prefix: stat.numberPrefix ?? '',
                suffix: stat.numberSuffix ?? '',
                content: parseHtml(stat.description),
                logo: logoObj,
              };
            }

            return {
              id: stat.id ?? '',
              countUp: false,
              statistic: stat.statistic ?? '',
              content: parseHtml(stat.description),
              logo: logoObj,
            };
          })
          .filter(notEmpty) ?? []
      }
    />
  );
};

export default StatisticsBlockModule;
